export enum DistributionBlockTypeApiEnum {
    title = 'TITLE',
    text = 'TEXT',
    image = 'IMAGE',
    divider = 'DIVIDER',
    button = 'BUTTON',
    code = 'CODE',
    footer = 'FOOTER',
    link = 'SOCIAL_LINKS',
    oneColumnLayout = 'SINGLE_COLUMN',
    twoColumnLayout = 'DOUBLE_COLUMN',
    threeColumnLayout = 'TRIPLE_COLUMN'
}
